import { getReadableFileType, toBoolean } from './dataHelper';

const passwordRegex = /^((.){8,})$/i;
const phoneNumberRegex = /^(07(\d){8})$/g;

function isValidTextInput(value, strict = true, regex = /\w+/) {
  if (strict === true && !toBoolean(value)) {
    return false;
  }

  const reg = new RegExp(regex);

  if (reg.test(value) === true || strict === false) {
    return true;
  }
  return false;
}

function isValidNumber(value, strictPattern = true) {
  const reg = new RegExp(strictPattern ? phoneNumberRegex : /\d+/g);
  //
  const is = reg.test(value);

  return is;
}

function isValidEmail(email) {
  const emailStr = email || '';
  const emailRegexTest = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g
    .test(emailStr);

  return !!emailRegexTest;
}

// eslint-disable-next-line no-useless-escape
const urlRegex = /^(https?:\/\/)?([\da-z\.-]+\.[a-z\.]{2,6}|[\d\.]+)([\/:?=&#]{1}[\da-z_\.-]+)*[\/\?]?$/igm;

function isValidUrl(url) {
  const reg = new RegExp(urlRegex);

  const is = reg.test(url);

  return !!is;
}

function isValidFile(file) {
  if (typeof file === 'object') {
    return !!getReadableFileType(file.type);
  }
  return !!getReadableFileType(file);
}

function isValidSelectInput(value) {
  if (Array.isArray(value)) {
    return value.every((v) => v !== undefined);
  }

  return value !== undefined;
}

function isValidDate(value) {
  try {
    const d = new Date(value);

    if (Number.isNaN(d.getFullYear())) {
      throw new Error('invalid');
    }

    return true;
  } catch (error) {
    return false;
  }
}

function passwordsMatch(password1, password2) {
  return password1 === password2 && isValidTextInput(password1, true, passwordRegex);
}

function isValidForm(form) {
  console.log('validating form: ', form);
  return true;
}

export default {
  isValidTextInput,
  isValidSelectInput,
  isValidEmail,
  isValidUrl,
  isValidNumber,
  passwordsMatch,
  isValidFile,
  isValidDate,
  isValidForm,
  passwordRegex,
};
